var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('LandingPage'),_c('DiscoverPage'),_c('SolutionsPage'),_c('BusinessPage'),_c('FooterPage'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }